// ============================================================
// SharedHighlights — replaces app-shared-highlights Angular component
// Renders the top summary cards (students / schools / staff / enrollment)
// ============================================================
import React from 'react';

export interface SubMenuItem {
  SubHeading: string;
  SubHeadingValue: number | string;
  SubHeadingValuePer?: string;
}

export interface HighlightCard {
  heading: string;
  headingValue: number | string;
  headingDate?: string;
  icon?: string;
  color?: string;
  subMenuItems?: SubMenuItem[];
}

interface SharedHighlightsProps {
  highLights: HighlightCard[];
  onCardClick?: (cardIndex: number) => void;
}

const SharedHighlights: React.FC<SharedHighlightsProps> = ({
  highLights,
  onCardClick,
}) => {
  if (!highLights || highLights.length === 0) return null;

  return (
    <div className="row mb-3">
      {highLights.map((card, idx) => (
        <div key={idx} className="col-12 col-sm-6 col-lg-4 mb-3">
          <div
            className="card h-100 shadow-sm"
            style={{
              cursor: onCardClick ? 'pointer' : 'default',
              borderLeft: `4px solid ${card.color ?? '#0b7db1'}`,
            }}
            onClick={() => onCardClick?.(idx)}
          >
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-bold text-muted small text-uppercase">
                  {card.heading}
                </span>
                {card.icon && (
                  <img
                    src={card.icon}
                    alt={card.heading}
                    style={{ width: 50, height: 50 }}
                  />
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h4
                  className="card-title mb-1"
                  style={{ color: card.color ?? '#0b7db1' }}
                >
                  {typeof card.headingValue === 'number'
                    ? card.headingValue.toLocaleString('en-IN')
                    : card.headingValue}
                </h4>
                {card.headingDate && (
                  <p className="text-muted small mb-2">
                    <strong>Last Updated Date:</strong>{' '}
                    {new Date(card.headingDate).toLocaleDateString('en-GB')}
                  </p>
                )}
              </div>
              {card.subMenuItems && card.subMenuItems.length > 0 && (
                <ul
                  className="list-unstyled mb-0 mt-2"
                  style={{ fontSize: 12 }}
                >
                  {card.subMenuItems.map((sub, sIdx) => (
                    <li
                      key={sIdx}
                      className="d-flex justify-content-between border-top pt-1"
                    >
                      <span className="text-muted">{sub.SubHeading}</span>
                      <span className="fw-semibold">
                        {typeof sub.SubHeadingValue === 'number'
                          ? sub.SubHeadingValue.toLocaleString('en-IN')
                          : sub.SubHeadingValue}
                        {sub.SubHeadingValuePer
                          ? ` (${sub.SubHeadingValuePer}%)`
                          : ''}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SharedHighlights;
